// ============================================================================
// Captura de lead (email cedo no funil, antes de criar conta) — grava na
// tabela `public.leads` que JÁ existe no schema (fitclutch_database_schema.sql,
// linha ~231) com esse propósito exato: "essa tabela existe pra guardar esse
// contato assim que o funil for ajustado pra capturar email mais cedo". É a
// base para email de recuperação/remarketing de quem não termina o funil.
//
// Diferente de `web_subscriptions`, essa tabela TEM policy de insert pra
// anon (`leads_insert_public`, `for insert with check (true)`) — por isso dá
// pra gravar direto daqui, sem precisar de Netlify Function/service role.
// ============================================================================
import { supabase } from './supabase.js';
import { currentLanguage } from '../i18n/strings.js';

const LOCALE_MAP = { pt: 'pt-BR', en: 'en', es: 'es', fr: 'fr', it: 'it', de: 'de', no: 'no', hi: 'hi' };

export async function saveLead(email, answers) {
  try {
    await supabase.from('leads').insert({
      email: email.trim().toLowerCase(),
      locale: LOCALE_MAP[currentLanguage] ?? 'en',
      // Marca a origem: hoje só o funil web (fitclutch-app + Stripe) grava
      // lead antes de criar conta. Quem compra pela App/Play Store passa
      // pelo IAP e não tem essa etapa — se um dia o mobile também capturar
      // email cedo, ele deve gravar aqui com lead_source: 'mobile_app',
      // pra dar pra filtrar/segmentar email marketing por plataforma.
      lead_source: 'web_funnel',
      onboarding_answers: answers ?? {},
      // 'quiz_completed' é o valor mais próximo disponível no enum
      // lead_funnel_stage pra "capturado durante o quiz" — a pessoa ainda
      // vai responder mais perguntas depois dessa tela, mas não existe um
      // estágio "em andamento" no enum hoje (só quiz_completed/
      // paywall_viewed/checkout_started/converted/abandoned/newsletter).
      funnel_stage: 'quiz_completed',
    });
  } catch (err) {
    // Nunca trava o funil por causa disso — mesmo padrão de
    // saveOnboardingResult em lib/auth.js.
    console.warn('Não foi possível salvar o lead no Supabase:', err?.message);
  }
}
